import { Field } from '@shopify/react-form';
import gettext from '@sdk/lang/gettext';

import { OutputDateFormatType } from '@web/forms/components/datePicker/datePicker.types';
import DatePickerField from '@web/forms/components/datePicker/DatePickerField/DatePickerField';
import ModalRow from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/ModalRow';
import { FieldContainer } from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/modalRow.styles';
import DateIconSvg from '@web/assets/svg/Icons/32/date-gray.svg';
import DateRowReadOnly from '@web/timesheets/CreateTimesheetModal/components/rows/DateRow/DateRowReadOnly';

type Props = {
  dateField: Field<Date>;
  isReadOnly?: boolean;
};
const DateRow = ({ dateField, isReadOnly }: Props) => (
  <ModalRow label={gettext('Date')} icon={DateIconSvg}>
    <FieldContainer>
      {isReadOnly ? (
        <DateRowReadOnly date={dateField.value} />
      ) : (
        <DatePickerField
          outputFormat={OutputDateFormatType.ddMMM}
          date={dateField.value}
          onDateChange={dateField.onChange}
        />
      )}
    </FieldContainer>
  </ModalRow>
);

export default DateRow;
